// extracted by mini-css-extract-plugin
export default {"cuadro":"CuadroTipoTorneo_cuadro__lesXk","tituloTorneos":"CuadroTipoTorneo_tituloTorneos__pZtto","listaTorneos":"CuadroTipoTorneo_listaTorneos__ZfRnK"};